import { useState, useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet-async";
import {
  Link as RouterLink,
  useNavigate,
  useParams,
  useLocation,
  NavLink,
} from "react-router-dom";
import { useForm } from "react-hook-form";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import $ from "jquery";
// @mui
import { styled } from "@mui/material/styles";
import { Button, Typography, Container, Box, Modal } from "@mui/material";
import { format } from "date-fns";
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from "../../utils/cryptoUtils";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "../common.scss";
import * as leadActions from "../../actions/leadActions";
 
import AccessDenied from "../common/AccessDenied";
 
 // ----------------------------------------------------------------------

const StyledContent = styled("div")(({ theme }) => ({
  maxWidth: 480,
  margin: "auto",
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  padding: theme.spacing(12, 0),
}));

const styles = {
  overlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.7)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  modal: {
    position: 'relative',
    width: '80%',
    height: '80%',
    backgroundColor: '#fff',
    borderRadius: '10px',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
  },
  closeButton: {
    position: 'absolute',
    top: 10,
    right: 15,
    fontSize: '24px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
  },
};

// ----------------------------------------------------------------------
const CheckPhoneInfo = (props) => {
  const { id, actionName } = useParams();
  const location = useLocation();
  const {
    actions} = props;
   
  const [leadId, setLeadId] = useState(""); 
   
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const navigate = useNavigate();

  const [showLeadCommunicationDetails, setShowLeadCommunicationDetails] =
    useState(false);
  const [allSourceData, setAllSource] = useState([]);
  const [allMasterProfiles, setAllMasterProfiles] = useState([]);
  const [allInteractionTypeData, setAllInteractionTypeData] = useState([]);
  const [allLeadStatusData, setAllLeadStatusData] = useState([]);
  const [allInteractions, setAllInteractions] = useState([]);
  const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
  const [pageHeading, setPageHeading] = useState("");
  const [questions, setQuestions] = useState([]);

  const [addModulePermissionStatus, setAddModulePermissionStatus] =
    useState(false);
  const [editModulePermissionStatus, setEditModulePermissionStatus] =
    useState(false);
  const [userHasPermission, setUserHasPermission] = useState(true);
  const [permissions, setPermissions] = useState([]);

  const [panDetailsInfoName, setPanDetailsInfoName] = useState("");
  const [phoneDetailsInfoName, setPhoneDetailsInfoName] = useState("");
  const [panDetailsInfoDoB, setPanDetailsInfoDoB] = useState("");
  const [panDetailsInfoGender, setPanDetailsInfoGender] = useState("");
  const [panDetailsInfoAddress, setPanDetailsInfoAddress] = useState("");
  const [leadPanDetails, setLeadPanDetails] = useState("");
  const [showTicketListDetails, setShowTicketListDetails] = useState(false);
  const [allTicketData, setAllTicketData] = useState([]);

  const [showListDetails, setShowListDetails] = useState(false);
  const [allGroupData, setAllGroupData] = useState([]);
  const [getAllUsersListData, setAllUsersListData] = useState([]);

  const [allLeadGstByLeadData, setAllLeadGstByLeadData] = useState([]);
  const [allLeadItrByLeadData, setAllLeadItrByLeadData] = useState([]);
  const [allLeadBankStatementByLeadData, setAllLeadBankStatementByLeadData] =
    useState([]);
    const [allLeadBankStatementCount, setAllLeadBankStatementCount] =
    useState(0);
  const [userRoleType, setUserRoleType] = useState("User");
  const [loggeInUserID, setLoggeInUserID] = useState("");
  const [isCrifUser, setIsCrifUser] = useState(true);
  const [isExternalUser, setIsExternalUser] = useState(false);

  const [allStates, setAllStates] = useState([]);
  const [allAddressTypes, setAllAddressTypes] = useState([]);
  const [showNote, setShowNote] = useState("");
  const [showNoteNoteByCredit, setShowNoteNoteByCredit] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [allPrefillTemplateNameData, setAllPrefillTemplateNameData] = useState(
    []
  );
  const [allCampaigns, setAllCampaigns] = useState([]);
  const [showActionLeadInfo, setShowActionLeadInfo] = useState(false);

  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedAssignedGroup, setSelectedAssignedGroup] = useState("");
  const [assignedUser, setAssignedUser] = useState("");

  const [isSentToCredit, setIsSentToCredit] = useState(true);

  const [allLeadActivity, setAllLeadActivity] = useState([]);
  const [preloaderStatus, setPreloaderStatus] = useState(false);
  const [preloaderStatusPhone, setPreloaderStatusPhone] = useState(false);
  const [actionType, setActionType] = useState("");
  const [activeTabName, setActiveTabName] = useState("basic");
  const [activeTab, setActiveTab] = useState("communication");

  const [allLeadCheckListScore, setAllLeadCheckListScore] = useState([]);
  const [allLeadCheckListDynamicScore, setAllLeadCheckListDynamicScore] =
    useState([]);

  const [creditAllLeadCheckLists, setCreditAllLeadCheckLists] = useState([]);
  const [scoreCard, setScoreCard] = useState("");
  const [allShipment, setAllShipment] = useState([]);
  const [leadStatusFlag, setLeadStatusFlag] = useState(false);
  const [outputBefiscHtml, setOutputBefiscHtml] = useState("");
  const [isExternalUserContent, setIsExternalUserContent] = useState("");
  const [mobileReadOnly, setMobileReadOnly] = useState(false);

  const [allOem, setAllOem] = useState([]);
  const [allOemUsage, setAllOemUsage] = useState([]);

  const [allFiSaveHistory, setAllFiSaveHistory] = useState([]);

  // lead Type start
  const [getAllChildsData1, setAllChildsData1] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState("");

  const [preloaderAadharStatus, setPreloaderAadharStatus] = useState(false);
  const [preloaderAadharOTPVerifyStatus, setPreloaderAadharOTPVerifyStatus] =
    useState(false);
  const [aadharVerifiedByName, setAadharVerifiedByName] = useState("");
  const [aadharVerifiedDate, setAadharVerifiedDate] = useState("");
  const [leadAadharDetails, setLeadAadharDetails] = useState("");
  const [skipAadharNumberToSave, setSkipAadharNumberToSave] = useState(true);
  const [aadharVerifiedStatus, setAadharVerifiedStatus] = useState(false);
  const [aadharOTPSentStatus, setAadharOTPSentStatus] = useState("0");
  const [aadharRefid, setAadharRefid] = useState("0");
  const [aadharValidationID, setAadharValidationID] = useState("");
  const [referenceId, setReferenceId] = useState("");
  const [isNameStyled, setIsNameStyled] = useState(false);
  const [isDobStyled, setIsDobStyled] = useState(false);
  const [isAddressStyled, setIsAddressStyled] = useState(false);
  const [isCityStyled, setIsCityStyled] = useState(false);
  const [isDistrictStyled, setIsDistrictStyled] = useState(false);
  
  const [isPinStyled, setIsPinStyled] = useState(false);
  const [senttoCreditStatus, setSenttoCreditStatus] = useState(false);
  const [enableCamDetailsStatus, setEnableCamDetailsStatus] = useState(false);
  const [vivritiChecklistStatus, setVivritiChecklistStatus] = useState(false);
  const [allDealers, setAllDealers] = useState([]);
  const selectRefDO = useRef(null);
  const selectRefSL = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [aadharDigiVerifiedByName, setAadharDigiVerifiedByName] = useState("");
  const [aadharDigiVerifiedDate, setAadharDigiVerifiedDate] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [profileAdvanceApiResponseArr, setProfileAdvanceApiResponseArr] = useState([]);
  
  const [formValues, setFormValues] = useState({
    phone: "",
  });
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handlePhoneDetails = () => {
    
    setPreloaderStatusPhone(true);
    const params = { phone_number: formValues.phone, "brief" : 'check_phone_information' };
    const requestData = encryptData(params);
    const response = actions.validateBefiscPhoneDetails(requestData);

    response
      .then((result) => {
        // console.log("Promise resolved - add/edit lead form:", result);
        setLeadPanDetails("");
        setProfileAdvanceApiResponseArr([]);
        if (result.data.success === 1) {
           // console.log("Befisc phone response = ", result.data.data);
          setPreloaderStatusPhone(false);
          toast.success(result.data.message, {
            position: "top-right",
          });

          let BefiscHtml = "";
          let BefiscStatus = "";

          if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "befiscApiRunStatus"
            ) &&
            result.data.data.befiscApiRunStatus
          ) {
            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "mobileage_response"
              )
            ) {
              const mobileageObj = result.data.data.mobileage_response;

              if (mobileageObj.length === 0) {
                BefiscHtml += `<span class="text-danger">Phone Number Age not found.</span>`;
              } else if (
                Object.prototype.hasOwnProperty.call(mobileageObj, "result") &&
                Object.prototype.hasOwnProperty.call(
                  mobileageObj.result,
                  "mobile_age"
                )
              ) {
                BefiscHtml += `<div>Mobile Age : ${mobileageObj.result.mobile_age}</div>`;
                BefiscStatus = "true";
              }
            }

            if (
              Object.prototype.hasOwnProperty.call(
                result.data.data,
                "multiple_upi_response"
              )
            ) {
              const upiObj = result.data.data.multiple_upi_response;

              if (upiObj.length === 0) {
                BefiscHtml += `<span class="text-danger">UPI Handle not found.</span>`;
              } else {
                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(upiObj.result, "name")
                ) {
                  BefiscHtml += `<div>Name : ${upiObj.result.name}</div>`;
                  BefiscStatus = "true";
                }

                if (
                  Object.prototype.hasOwnProperty.call(upiObj, "result") &&
                  Object.prototype.hasOwnProperty.call(upiObj.result, "upi") &&
                  Array.isArray(upiObj.result.upi)
                ) {
                  BefiscHtml += `<div>UPIs : ${upiObj.result.upi.join(
                    ", "
                  )}</div>`;
                  BefiscStatus = "true";
                }
              }
            }

            if (
            Object.prototype.hasOwnProperty.call(
              result.data.data,
              "profileAdvanceResponse"
            ) &&
            result.data.data.profileAdvanceResponse
          ) { 
              const apiResponseObj = result.data.data.profileAdvanceResponse; 
               console.log("0000 Befisc Profile advance = ", apiResponseObj);
              setProfileAdvanceApiResponseArr(apiResponseObj); 
           
          } 
          } else {
            BefiscHtml += `<span class="text-danger">UPI Handle and Phone Number API not run.</span><span>Please click the <b>'Get Phone Number Age + UPI Handle'</b> button.</span> `;
          }

          setOutputBefiscHtml(BefiscHtml);
          setPhoneDetailsInfoName(BefiscStatus);
        } else {
          setPreloaderStatusPhone(false);
          toast.error(result.data.message, {
            position: "top-right",
          });
        }
      })
      .catch((error) => {
        setPreloaderStatusPhone(false);
        // console.error("Promise rejected - add/edit lead form:", error);
        toast.error(error, {
          position: "top-right",
        });
      });
  };

    

  if (!userHasPermission) {
    // Redirect or render an access denied message
    return <AccessDenied />;
  }

  return (
    <>
      <Helmet>
        <title> {leadId === "" ? "Check Phone Information" : "Check Phone Information"} Lead | Ckers </title>
      </Helmet>
      <Container>
        <div className="row align-items-center"> 
          <div className="col-md-12">
            <Typography variant="h4" sx={{ mb: 5 }}>
              {leadId === "" ? (
                "Check Phone Information"
              ) : (
                <>
                  {pageHeading}
                  <br />
                  <Typography variant="body3" sx={{ color: "red" }}>
                    {isExternalUserContent}
                  </Typography>
                </>
              )}
            </Typography>
          </div>
 
        </div>

        <div id="main-wrap" className="mb-5">
              <div className="tab-content" id="pills-tabContent">
              <form>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="phone">
                    <span>
                      Phone Number{" "}
                      <a style={{ color: "red" }}>* </a>
                    </span>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className="form-control "
                      {...register("phone")}
                      value={formValues.phone}
                      onChange={handleChange}
                      readOnly={
                        userRoleType === "Credit" ||
                        leadStatusFlag === true ||
                        mobileReadOnly === true
                      }
                    /> 
                            <button
                              type="button"
                              className="btn btn-success float-right validate-phone"
                              onClick={() =>
                                handlePhoneDetails()
                              }
                            >
                              {preloaderStatusPhone && (
                                <>
                                  <div
                                    className="spinner-border small-preloader"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      {" "}
                                      Loading...
                                    </span>
                                  </div>
                                </>
                              )}
                              Get Phone Number Age + UPI Handle
                            </button>
                            
                    
                  </label>
                  {errors.phone && (
                    <span className="required">
                      {" "}
                      This field is required.
                    </span>
                  )}
                </div>

                {!isExternalUser && (
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: outputBefiscHtml.replace(
                          /\n/g,
                          "<br />"
                        ),
                      }}
                    />
                  </>
                )}
              </div>

              
            </div>
          </form> 

          {profileAdvanceApiResponseArr.map((item, index) => ( 
                      <div className="row detailsRow">
                         <div className="col-md-12">
                           <hr />
                            <ul>
                              <li><strong>Full name : </strong> {item?.result?.personal_information?.full_name}</li>

                              <li><strong>Gender : </strong> {item?.result?.personal_information?.gender}</li>

                              <li><strong>Age : </strong> {item?.result?.personal_information?.age}</li>

                              <li><strong>Date of birth : </strong> {item?.result?.personal_information?.date_of_birth}</li>

                              <li><strong>Income : </strong> {item?.result?.personal_information?.income}</li> 
                          
                          </ul>

                          {item.result?.alternate_phone && item.result.alternate_phone?.length > 0 && (
                            <>
                              <hr />
                                <h5>Alternate Phone Numbers</h5>
                                <ul>
                                  {item.result.alternate_phone.map((phone) => (
                                    phone.value?.trim() && (
                                      <li key={phone.serial_number}>
                                        {phone.serial_number}. {phone.value}
                                      </li>
                                    )
                                  ))}
                                </ul>
                                <hr />
                            </>
                          )}

                          {item.result?.email && item.result?.email.length > 0 && (
                            <>
                              <h5>Email Addresses</h5>
                              <ul>
                                {item.result.email.map((email) =>
                                  email.value?.trim() && (
                                    <li key={email.serial_number}>
                                      {email.serial_number}. {email.value}
                                    </li>
                                  )
                                )}
                              </ul>
                               <hr />
                            </>
                          )}


                          {item.result?.address && item.result?.address.length > 0 && (
                          <>
                            <h5>Addresses</h5>
                            <ul>
                              {item.result.address.map((row, index) => (
                                <li key={index} style={{ marginBottom: '1rem' }}>
                                  <strong>Address:</strong> {row.detailed_address}<br />
                                  <strong>State:</strong> {row.state}<br />
                                  <strong>Pincode:</strong> {row.pincode}<br />
                                  <strong>Date of Reporting:</strong> {row.date_of_reporting}
                                </li>
                              ))}
                            </ul>
                             <hr />
                          </>
                        )}

                        {item.result?.document_data?.pan?.length > 0 && (
                        <>
                          <h5>PAN Details</h5>
                          <ul>
                            {item.result.document_data.pan.map((row, index) => (
                              <li key={index}>
                                <strong>Serial Number:</strong> {row.serial_number}<br />
                                <strong>Value:</strong> {row.value}
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                         
                    </div>
                    </div>
                          
                          
                  ))}
         
        </div>
        </div>
      </Container> 
    </>
  );
};
function mapStateToProps(state) {
  return {
    leadsData: state.leadsData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      Object.assign(
        leadActions.default
      ),
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckPhoneInfo);